import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import { studySiteManagementServices } from "../../../APIServices/CTMS/SiteManagement/studySiteManagementServices";

const UpdateSiteThreshold = ({
  rowData,
  Show,
  Hide,
  Title,
  getStudyEIWRSSiteInventory,
}) => {
  const [siteRow, setSiteRow] = useState({});
  const [siteColumns, setSiteColumns] = useState([]);
  const [loader, setLoader] = useState([]);
  const [buttonLoader, setButtonLoader] = useState(false);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const handleSiteRowChange = (e, columnKey) => {
    setSiteRow({
      ...siteRow,
      [columnKey]: e.target.value,
    });
  };
  let { studyId } = useParams()

  const updateStudySiteRowData = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Update Site!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.id = rowData?._id;
        userData.studyId = studyId;
        userData.siteRow = siteRow;
        let data = await studySiteManagementServices.updateStudySiteRowData(userData);
        if (data?.statusCode === 200) {
          getStudyEIWRSSiteInventory();
          Hide()
        }
      }
      setButtonLoader(false);
    });
  };

  const getSingleSiteData = async() => {
    let data = await studySiteManagementServices.getSingleSiteData(studyId, rowData?.siteId)
    setSiteRow(data?.siteData?.row, {})
  }

  useEffect(() => {
    if(rowData){
      getSingleSiteData();
    }
  }, [rowData]);

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Label className="mb-1 fw-bold">
            Threshold <abbr className="text-danger">*</abbr>
          </Form.Label>
          <Form.Control
            onChange={(e) => handleSiteRowChange(e, (StudyMode === "DBP Mode" ? "EIWRSDBPKITTHRESHOLD" : StudyMode === "Live Mode" ? "EIWRSLIVEKITTHRESHOLD" : "EIWRSQCKITTHRESHOLD"))}
            value={siteRow?.[StudyMode === "DBP Mode" ? "EIWRSDBPKITTHRESHOLD" : StudyMode === "Live Mode" ? "EIWRSLIVEKITTHRESHOLD" : "EIWRSQCKITTHRESHOLD"] || ""}
            className="br3"
            placeholder={`Enter Threshold`}
            type="number"
          />
        </Offcanvas.Body>
        <div className="p-2 bg-light border-top shadow-sm text-end">
          <button
            disabled={!siteRow?.[StudyMode === "DBP Mode" ? "EIWRSDBPKITTHRESHOLD" : StudyMode === "Live Mode" ? "EIWRSLIVEKITTHRESHOLD" : "EIWRSQCKITTHRESHOLD"] || buttonLoader}
            onClick={updateStudySiteRowData}
            className="updateProfile"
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Updating...
              </div>
            ) : (
              "Update Threshold"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default UpdateSiteThreshold;